define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'amdi18n-loader?!view/nls/AuthenticationOptionView_strings',
	'lib/jquery',
	'lib/bootstrap/tooltip' // doesn't export
], function (
	Util,
	UiUtil,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * AuthenticationOptionView class
	 */
	return function () {
		var _view = jQuery("<div class='skIdS_authentication-option'>");


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (authenticationOption, showCloudIDIcon, showFido) {
                    _view.empty()
				.append("<img class='skIdS_authentication-option-image' src='" + authenticationOption.image().url() + "'>");

			if (showCloudIDIcon) {
				_view.append('<img class="skIdS_authentication-option-cloudid" src="' + UiUtil.getImage('CLOUDID_ICON').url() + '">');

				this.enableToolTip(Strings.cloud_identity + '<br>(' + authenticationOption.description() + ')');
			} else {
				this.enableToolTip(authenticationOption.description());
			}
			if (showFido) {
				_view.append('<img class="skIdS_authentication-option-cloudid fido-icon" src="' + UiUtil.getImage('FIDO_ICON').url() + '">');
			}
		};

		this.enable = function (animate) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.children('.skIdS_authentication-option-image').removeClass('skIdS_fade');
			} else {
				_view.children('.skIdS_authentication-option-image').addClass('skIdS_fade');
			}


			_view.children('.skIdS_authentication-option-image').removeClass('skIdS_disabled');
		};

		this.disable = function (animate) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.children('.skIdS_authentication-option-image').removeClass('skIdS_fade');
			} else {
				_view.children('.skIdS_authentication-option-image').addClass('skIdS_fade');
			}

			_view.children('.skIdS_authentication-option-image').addClass('skIdS_disabled');
		};

		this.enableCloudID = function (animate) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.children('.skIdS_authentication-option-cloudid').removeClass('skIdS_fade');
			} else {
				_view.children('.skIdS_authentication-option-cloudid').addClass('skIdS_fade');
			}

			_view.children('.skIdS_authentication-option-cloudid').removeClass('skIdS_disabled');
		};

		this.disableCloudID = function (animate) {
			if (typeof animate !== 'undefined' && !animate) {
				_view.children('.skIdS_authentication-option-cloudid').removeClass('skIdS_fade');
			} else {
				_view.children('.skIdS_authentication-option-cloudid').addClass('skIdS_fade');
			}

			_view.children('.skIdS_authentication-option-cloudid').addClass('skIdS_disabled');
		};

		this.enableToolTip = function (message) {
			var toolTipVisible = false;

			if (!Util.isValidString(message)) {
				return;
			}

			if (_view.attr('data-original-title') === undefined) {
				_view.tooltip({ html : true });
			}

			_view.tooltip('enable');

			if (_view.next('.tooltip').is(':visible')) {
				_view.tooltip('hide');
				toolTipVisible = true;
			}

			_view.attr('data-original-title', message);

			if (toolTipVisible) {
				_view.trigger('mouseenter');
				_view.tooltip('show');
			}
		};

		this.disableToolTip = function () {
			if (_view.next('.tooltip').is(':visible')) {
				_view.tooltip('hide');
			}

			_view.tooltip('disable');
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/AuthenticationOptionView.js
// module id = 54
// module chunks = 1